import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "post-create-container" }
const _hoisted_2 = { class: "post-create-wrapper" }
const _hoisted_3 = { class: "content-with-ai-btn" }
const _hoisted_4 = { class: "media-uploader-container" }
const _hoisted_5 = {
  key: 0,
  class: "cover-image-container"
}
const _hoisted_6 = { class: "cover-image-wrapper" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "media-overlay" }
const _hoisted_9 = { class: "media-uploader-container" }
const _hoisted_10 = {
  key: 0,
  class: "media-grid-container"
}
const _hoisted_11 = { class: "media-item-wrapper" }
const _hoisted_12 = { class: "media-item" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "media-overlay" }
const _hoisted_15 = { class: "media-type" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "upload-progress-item" }
const _hoisted_18 = { class: "media-uploader-container" }
const _hoisted_19 = {
  key: 0,
  class: "media-grid-container"
}
const _hoisted_20 = {
  key: 0,
  class: "upload-progress-container"
}
const _hoisted_21 = { class: "upload-progress-item" }
const _hoisted_22 = { class: "video-item" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "video-overlay" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "dialog-footer" }
const _hoisted_27 = { class: "polish-comparison-container" }
const _hoisted_28 = { class: "comparison-panel" }
const _hoisted_29 = { class: "content-panel original-content" }
const _hoisted_30 = { class: "comparison-panel" }
const _hoisted_31 = { class: "content-panel polished-content" }
const _hoisted_32 = {
  key: 0,
  class: "loading-indicator"
}
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { class: "dialog-footer comparison-footer" }

import { ref, reactive, computed, nextTick } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Plus, Loading } from '@element-plus/icons-vue'
import { useStore } from 'vuex'
import { createPost, uploadCoverImage, uploadImages, uploadVideo, createPostWithMedia, createPostNew, getMediaInfo, type MediaItem, polishContent } from '@/user/api/post'
import draggable from 'vuedraggable'
import MarkdownIt from 'markdown-it'

// 定义emit事件

export default /*@__PURE__*/_defineComponent({
  __name: 'PostCreateView',
  emits: ['post-created', 'cancel'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const store = useStore()

// 表单数据
const form = reactive({
  title: '',
  content: '',
  coverImage: '',
  coverImageWidth: 0,
  coverImageHeight: 0
})

// 媒体数据 - 使用shallowReactive以避免深层响应式代理导致的问题
const imageList = ref<any[]>([]);
const videoList = ref<any[]>([]);
const uploadingMedia = ref(false);
const imageInputRef = ref<HTMLInputElement>();
const videoInputRef = ref<HTMLInputElement>();
const coverInputRef = ref<HTMLInputElement>() // 新增封面图片输入引用

// 添加上传进度相关状态
const imageUploadProgress = ref<{ [key: number]: number }>({}); // 图片上传进度
const videoUploadProgress = ref<number>(0); // 视频上传进度

// AI润色相关状态
const showPolishInstructionDialog = ref<boolean>(false);
const showPolishResultDialog = ref<boolean>(false);
const polishInstruction = ref<string>('让语言更生动有趣');
const isPolishing = ref<boolean>(false);
const polishedContent = ref<string>('');
const md = new MarkdownIt();

// 渲染后的Markdown内容
const renderedPolishedContent = computed(() => {
  return polishedContent.value ? md.render(polishedContent.value) : '';
});

// 验证规则
const rules = {
  title: [
    { required: true, message: '请输入帖子标题', trigger: 'blur' },
    { min: 1, max: 100, message: '标题长度应在1-100字符之间', trigger: 'blur' }
  ],
  content: [
    { required: true, message: '请输入帖子内容', trigger: 'blur' },
    { min: 1, max: 10000, message: '内容长度应在1-10000字符之间', trigger: 'blur' }
  ]
}

// 开始AI润色
const startPolishContent = async () => {
  if (!form.content.trim()) {
    ElMessage.warning('请先输入帖子内容');
    return;
  }
  

  showPolishInstructionDialog.value = false;
  showPolishResultDialog.value = true;
  isPolishing.value = true;
  polishedContent.value = '';

  
  try {
    const token = store.state.token || localStorage.getItem('token'); // 获取token

    const apiResponse = await fetch('/api/user/post/polish', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'token': token || '' // 根据项目规范，使用token字段而不是Authorization: Bearer
      },
      body: JSON.stringify({
        content: form.content,           // 需要润色的原始内容
        instruction: polishInstruction.value || '让语言更生动有趣'  // 润色指令
      })
    });


    if (!apiResponse.ok) {
      throw new Error(`润色请求失败: ${apiResponse.status} ${apiResponse.statusText}`);
    }

    const reader = apiResponse.body.getReader();
    const decoder = new TextDecoder('utf-8');
    let buffer = ''; // 用于处理可能分割的数据块


    let shouldContinue = true;
    while (shouldContinue) {
      const { done, value } = await reader.read();

      
      if (done) {

        shouldContinue = false;
        break;
      }

      // 解码当前数据块
      const chunk = decoder.decode(value, { stream: true });

      
      buffer += chunk;
      
      // 按行分割缓冲区
      const lines = buffer.split('\n');

      
      // 保留最后一个不完整的行
      buffer = lines.pop() || '';
      
      // 遍历所有行进行处理
      for (let i = 0; i < lines.length; i++) {
        const line = lines[i];

        
        // 检查是否以 'data:' 开头（兼容带空格和不带空格的格式）
        if (line.startsWith('data:')) {

          
          // 提取冒号后的部分，兼容 'data:content' 和 'data: content' 两种格式
          let data = line.substring(5); // 移除 'data:' 部分
          data = data.trimStart(); // 去除开头可能的空格
          

          
          // 检查是否是结束标记（如果有的话）
          if (data === '[DONE]' || data === '') {

            continue;
          }
          
          // 将数据追加到润色内容中

          const previousValue = polishedContent.value;
          
          // 检查当前内容是否以换行符结尾，如果不是且新数据非空，则添加换行符
          if (polishedContent.value.length > 0 && !polishedContent.value.endsWith('\n') && data) {
            polishedContent.value += '\n';
          }
          
          polishedContent.value += data;

          
          // 强制触发Vue响应式更新
          await nextTick();
        } else if (line.trim() === '') {
          // 忽略空行
          console.log('检测到空行，跳过');
        } else {
          console.log('非数据行，跳过:', JSON.stringify(line));
        }
      }
    }
    
    // 处理缓冲区中剩余的数据（防止末尾数据丢失）
    if (buffer) {
      console.log('处理缓冲区中剩余数据:', JSON.stringify(buffer));
      if (buffer.startsWith('data:')) {
        let data = buffer.substring(5); // 移除 'data:' 部分
        data = data.trimStart(); // 去除开头可能的空格
        
        if (data !== '[DONE]' && data !== '') {
          console.log('处理缓冲区最后的数据:', JSON.stringify(data));
          if (polishedContent.value.length > 0 && !polishedContent.value.endsWith('\n') && data) {
            polishedContent.value += '\n';
          }
          polishedContent.value += data;
        }
      }
    }
    

    
    // 如果最终值为空，输出警告
    if (!polishedContent.value) {
      console.warn('polishedContent最终值为空，可能处理过程中出现问题');
    }
  } catch (error: any) {
    console.error('润色内容失败:', error);
    ElMessage.error('润色内容失败: ' + (error.message || '未知错误'));
  } finally {
    isPolishing.value = false;

  }
};

// 接受润色后的内容
const acceptPolishedContent = () => {
  if (polishedContent.value) {
    form.content = polishedContent.value;
    ElMessage.success('已接受润色后的内容！');
    showPolishResultDialog.value = false;
  }
};

// 处理媒体URL，在开发环境中为本地路径添加/api前缀
const processMediaUrl = (url: string | undefined): string => {
  if (!url) {
    return ''; // 如果url是undefined或空值，直接返回空字符串
  }
  
  if (process.env.NODE_ENV === 'development') {
    // 如果是完整URL（以http/https开头）或已经带有/api前缀，则直接返回
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('/api')) {
      return url;
    }
    // 如果是本地路径（以/开头），添加/api前缀
    else if (url.startsWith('/')) {
      return `/api${url}`;
    }
    // 其他情况返回原URL
    return url;
  }
  return `/api${url}`; // 生产环境返回原URL
};

// 提交状态
const submitting = ref(false)
const createFormRef = ref()

// 声明响应式变量
const selectedImageIndex = ref<number>(-1); // 用于图片排序

// 处理图片文件变化
const handleImageFilesChange = async (event: Event) => {
  const target = event.target as HTMLInputElement;
  const files = Array.from(target.files || []);
  
  if (files.length === 0) return;

  // 检查总文件数量
  if (imageList.value.length + files.length > 9) {
    ElMessage.error('图片总数不能超过9张！');
    return;
  }

  // 检查文件大小（单个文件不超过10MB，总计不超过100MB）
  const MAX_SINGLE_FILE_SIZE = 10 * 1024 * 1024; // 10MB
  const MAX_TOTAL_SIZE = 100 * 1024 * 1024; // 100MB
  
  let totalSize = 0;
  for (const file of files) {
    if (file.size > MAX_SINGLE_FILE_SIZE) {
      ElMessage.error(`${file.name} 文件大小超过10MB，请压缩后再上传`);
      return;
    }
    totalSize += file.size;
  }
  
  // 检查总大小
  if (totalSize > MAX_TOTAL_SIZE) {
    ElMessage.error('所选图片总大小超过100MB，请减少图片或压缩后再上传');
    return;
  }

  uploadingMedia.value = true;

  try {
    // 初始化进度
    files.forEach((file, index) => {
      const fileId = Date.now() + index;
      imageUploadProgress.value[fileId] = 0;
    });

    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });

    // 上传图片并监听进度
    const imageResponses = await uploadImages(formData, (progressEvent: any) => {
      const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      // 更新所有图片的平均进度
      Object.keys(imageUploadProgress.value).forEach(key => {
        imageUploadProgress.value[Number(key)] = progress;
      });
    });

    if (imageResponses.code === 1) {
      // 添加到图片列表
      for (let i = 0; i < imageResponses.data.length; i++) {
        let url = imageResponses.data[i];
        
        // 在开发环境中，为图片URL添加/api前缀以通过代理访问
        
        const mediaInfo = await getMediaInfo(url); // 直接传递处理后的URL
        
        const newImage = {
          id: Date.now() + Math.random(),
          mediaUrl: url,
          mediaType: 1 as const, // 1 表示图片
          width: mediaInfo.width,
          height: mediaInfo.height,
          sortOrder: imageList.value.length + i + 1
        };
        
        // 使用push而不是直接赋值，以确保vuedraggable能正确追踪变化
        imageList.value.push(newImage);
      }
      
      ElMessage.success(`成功上传 ${files.length} 张图片`);
    } else {
      ElMessage.error(imageResponses.msg || '图片上传失败');
    }
  } catch (error) {
    console.error('上传图片失败:', error);
    // 检查是否是413错误
    if (error && typeof error === 'object' && 'response' in error && (error as any).response?.status === 413) {
      ElMessage.error('图片文件过大，请压缩后再上传');
    } else {
      ElMessage.error('上传图片失败，请重试');
    }
  } finally {
    // 清除进度
    imageUploadProgress.value = {};
    uploadingMedia.value = false;
    // 清空input值，以便可以重复选择同一文件
    if (target) {
      target.value = '';
    }
  }
}

// 处理视频文件变化
const handleVideoFileChange = async (event: Event) => {
  const target = event.target as HTMLInputElement;
  const files = Array.from(target.files || []);
  
  if (files.length === 0) return;

  // 检查视频数量（最多一个视频）
  if (videoList.value.length >= 1) {
    ElMessage.warning('最多只能上传1个视频');
    return;
  }

  // 检查文件大小（单个视频不超过500MB）
  const MAX_VIDEO_FILE_SIZE = 500 * 1024 * 1024; // 500MB
  
  const file = files[0];
  if (file.size > MAX_VIDEO_FILE_SIZE) {
    ElMessage.error(`${file.name} 文件大小超过500MB，请压缩后再上传`);
    return;
  }

  uploadingMedia.value = true;
  videoUploadProgress.value = 0; // 初始化视频上传进度

  try {
    // 上传视频并监听进度
    const videoResponse = await uploadVideo(file, (progressEvent: any) => {
      videoUploadProgress.value = Math.round((progressEvent.loaded * 100) / progressEvent.total);
    });

    if (videoResponse.code === 1) {
      let url = videoResponse.data;
      
      const mediaInfo = await getMediaInfo(url); // 直接传递处理后的URL
      
      const newVideo = {
        id: Date.now() + Math.random(),
        mediaUrl: url,
        mediaType: 2 as const, // 2 表示视频
        width: mediaInfo.width,
        height: mediaInfo.height,
        duration: mediaInfo.duration,
        thumbnailUrl: '' // 添加空的缩略图URL
      };
      videoList.value.push(newVideo);
      ElMessage.success('视频上传成功');
    } else {
      ElMessage.error(videoResponse.msg || '视频上传失败');
    }
  } catch (error) {
    console.error('上传视频失败:', error);
    // 检查是否是413错误
    if (error && typeof error === 'object' && 'response' in error && (error as any).response?.status === 413) {
      ElMessage.error('视频文件过大，请压缩后再上传');
    } else {
      ElMessage.error('上传视频失败，请重试');
    }
  } finally {
    videoUploadProgress.value = 0; // 清除视频上传进度
    uploadingMedia.value = false;
    // 清空input值，以便可以重复选择同一文件
    if (target) {
      target.value = '';
    }
  }
}

// 处理封面文件变化
const handleCoverFileChange = async (event: Event) => {
  const target = event.target as HTMLInputElement;
  const files = target.files;
  
  if (!files || files.length === 0) {
    console.error('未找到选择的文件');
    return;
  }

  const file = files[0];
  
  const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
  // 降低文件大小限制，从20MB降到5MB，以避免413错误
  const isLt5M = file.size < 5 * 1024 * 1024;

  if (!isJPG) {
    ElMessage.error('上传封面图片只能是 JPG/PNG/GIF 格式!');
    // 清空input值
    target.value = '';
    return;
  }
  if (!isLt5M) {
    ElMessage.error('上传封面图片大小不能超过 5MB!');
    // 清空input值
    target.value = '';
    return;
  }

  try {
    console.log('开始上传文件:', {
      name: file.name,
      type: file.type,
      size: file.size
    });

    const response = await uploadCoverImage(file);
    
    console.log('上传响应:', response);
    
    if (response && response.code === 1) {
      let coverImageUrl = response.data;
      
      // 封面图片是OSS存储的完整URL，不需要添加/api前缀
      // 直接使用后端返回的完整URL
      
      try {
        // 对于OSS上的图片，使用原始URL获取媒体信息
        const mediaInfo = await getMediaInfo(coverImageUrl);
        form.coverImageWidth = mediaInfo.width;
        form.coverImageHeight = mediaInfo.height;
      } catch (error) {
        console.error('获取封面图片媒体信息失败:', error);
        // 即使获取媒体信息失败，也不影响主流程
      }
      
      form.coverImage = coverImageUrl;
      ElMessage.success('封面图片上传成功!');
    } else {
      const errorMsg = response?.msg || '封面图片上传失败';
      ElMessage.error(errorMsg);
    }
  } catch (error: any) {
    console.error('上传失败:', error);
    // 检查是否是413错误
    if (error && typeof error === 'object' && 'response' in error && (error as any).response?.status === 413) {
      ElMessage.error('封面图片文件过大，请压缩后再上传');
    } else {
      let errorMessage = '封面图片上传失败';
      
      if (error.response && error.response.data && error.response.data.msg) {
        errorMessage = error.response.data.msg;
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      ElMessage.error(errorMessage);
    }
  } finally {
    // 清空input值，以便可以重复选择同一文件
    if (target) {
      target.value = '';
    }
  }
}

// 删除封面图片
const removeCoverImage = () => {
  form.coverImage = '';
  ElMessage.info('封面图片已删除');
}

// 触发封面上传
const triggerCoverUpload = () => {
  coverInputRef.value?.click()
}

// 触发图片上传
const triggerImageUpload = () => {
  if (imageList.value.length >= 9) {
    ElMessage.warning('最多只能上传9张图片');
    return;
  }
  imageInputRef.value?.click();
}

// 触发视频上传
const triggerVideoUpload = () => {
  if (videoList.value.length >= 1) {
    ElMessage.warning('最多只能上传1个视频');
    return;
  }
  videoInputRef.value?.click();
}

// 删除媒体
const removeMedia = (id: number, type: 'image' | 'video') => {
  if (type === 'image') {
    const index = imageList.value.findIndex(item => item.id === id);
    if (index !== -1) {
      imageList.value.splice(index, 1);
      // 重新排序
      imageList.value.forEach((item, index) => {
        item.sortOrder = index + 1;
      });
    }
  } else {
    const index = videoList.value.findIndex(item => item.id === id);
    if (index !== -1) {
      videoList.value.splice(index, 1);
    }
  }
}

// 重置表单
const resetForm = () => {
  // 重置表单数据
  form.title = ''
  form.content = ''
  form.coverImage = undefined
  imageList.value = []
  videoList.value = []
  selectedImageIndex.value = -1
  
  // 清空验证
  if (createFormRef.value) {
    createFormRef.value.clearValidate()
  }
}

// 取消发布
const cancel = () => {
  // 关闭发布帖子对话框，而不是返回上一页
  try {
    emit('cancel')
  } catch (error) {
    console.error('Error emitting cancel event:', error)
  }
}

// 处理拖拽结束事件
const onDragEnd = (event: any) => {
  console.log(`图片位置从 ${event.oldIndex} 调整至 ${event.newIndex}`);
  ElMessage.success('图片顺序已更新');
}

// 提交表单
const submitForm = async () => {
  if (!form.title.trim()) {
    ElMessage.warning('请输入帖子标题');
    return;
  }

  if (!form.content.trim()) {
    ElMessage.warning('请输入帖子内容');
    return;
  }

  try {
    submitting.value = true;
    
    // 显示审核中提示
    ElMessage.info('帖子提交成功，正在审核中...');
    
    // 合并所有媒体文件
    const allMediaItems: MediaItem[] = [
      ...imageList.value.map(item => ({ 
        mediaUrl: item.mediaUrl, 
        mediaType: item.mediaType,
        width: item.width,
        height: item.height,
        sortOrder: item.sortOrder
      })),
      ...videoList.value.map(item => ({ 
        mediaUrl: item.mediaUrl, 
        mediaType: item.mediaType,
        width: item.width,
        height: item.height,
        duration: item.duration,
        // 视频不需要排序序号，但为了接口一致性保留
        sortOrder: item.sortOrder
      }))
    ];

    const postData = {
      title: form.title,
      content: form.content,
      coverImage: form.coverImage || undefined, // 如果没有封面图片则不传递
      mediaList: allMediaItems.length > 0 ? allMediaItems : undefined // 如果没有媒体文件则不传递
    };

    console.log('正在发送发布帖子请求:', postData);
    const response = await createPostNew(postData); // 使用正确的API路径
    console.log('API响应:', response);
    
    // 检查响应数据是否存在
    if (!response) {
      ElMessage.error('发布帖子失败：响应数据为空');
      return;
    }
    
    // 检查响应数据结构
    if (typeof response !== 'object') {
      ElMessage.error('发布帖子失败：响应数据格式错误');
      return;
    }
    
    // 检查code字段是否存在
    if (response.code === undefined) {
      ElMessage.error(`发布帖子失败：缺少状态码，响应内容：${JSON.stringify(response)}`);
      return;
    }
    
    if (response.code === 1) {
      // 发布成功后，提示用户帖子正在审核中
      ElMessage.success(response.msg || '帖子发布成功！我们将在后台审核您的内容，审核结果会在个人中心显示。');
      
      // 重置表单
      resetForm();
      
      // 触发帖子创建成功的事件
      emit('post-created');
    } else {
      ElMessage.error(response.msg || '帖子发布失败');
    }
  } catch (error: any) {
    console.error('发布帖子失败:', error);
    let errorMessage = '发布帖子失败，请稍后重试';
    
    // 如果错误有详细消息，使用详细消息
    if (error.response && error.response.data && error.response.data.msg) {
      errorMessage = error.response.data.msg;
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    ElMessage.error(errorMessage);
  } finally {
    submitting.value = false;
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "create-header" }, [
        _createElementVNode("h2", null, "📝 发布新帖子"),
        _createElementVNode("p", null, "分享您的钩织作品与心得")
      ], -1)),
      _createVNode(_component_el_form, {
        model: form,
        rules: rules,
        ref_key: "createFormRef",
        ref: createFormRef,
        "label-width": "100px",
        class: "post-create-form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "帖子标题",
            prop: "title"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.title) = $event)),
                placeholder: "请输入帖子标题",
                maxlength: "100",
                "show-word-limit": "",
                class: "custom-input"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "帖子内容",
            prop: "content"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_input, {
                  modelValue: form.content,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.content) = $event)),
                  type: "textarea",
                  rows: 6,
                  placeholder: "请输入帖子内容，分享您的钩织经验、技巧或展示作品...",
                  maxlength: "10000",
                  "show-word-limit": "",
                  class: "custom-textarea"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", {
                  class: "ai-btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (showPolishInstructionDialog.value = true))
                }, "AI")
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "封面图片" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: "media-upload-area",
                  onClick: triggerCoverUpload,
                  style: {"height":"150px"}
                }, [
                  _createElementVNode("input", {
                    ref_key: "coverInputRef",
                    ref: coverInputRef,
                    type: "file",
                    accept: "image/*",
                    onChange: handleCoverFileChange,
                    style: {"display":"none"}
                  }, null, 544),
                  (!form.coverImage)
                    ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Plus))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                (form.coverImage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("img", {
                          src: form.coverImage,
                          class: "cover-image"
                        }, null, 8, _hoisted_7)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "media-type" }, "封面", -1)),
                        _createElementVNode("i", {
                          class: "delete-btn",
                          onClick: _withModifiers(removeCoverImage, ["stop"])
                        }, "×")
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _cache[10] || (_cache[10] = _createElementVNode("p", { class: "image-tip" }, "推荐尺寸：宽高比16:9，大小不超过2MB", -1))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "内容图片" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: "media-upload-area",
                  onClick: triggerImageUpload
                }, [
                  _createElementVNode("input", {
                    ref_key: "imageInputRef",
                    ref: imageInputRef,
                    type: "file",
                    multiple: "",
                    accept: "image/*",
                    onChange: handleImageFilesChange,
                    style: {"display":"none"}
                  }, null, 544),
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Plus))
                    ]),
                    _: 1
                  }),
                  _cache[11] || (_cache[11] = _createElementVNode("span", null, "添加图片", -1))
                ]),
                (imageList.value.length > 0 || Object.keys(imageUploadProgress.value).length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_unref(draggable), {
                        modelValue: imageList.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((imageList).value = $event)),
                        "item-key": "id",
                        class: "media-grid",
                        "ghost-class": "drag-ghost",
                        "chosen-class": "drag-chosen",
                        "drag-class": "dragging",
                        onEnd: onDragEnd
                      }, {
                        item: _withCtx(({ element, index }) => [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("img", {
                                src: processMediaUrl(element.mediaUrl),
                                class: "media-preview"
                              }, null, 8, _hoisted_13),
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("span", _hoisted_15, "图片 " + _toDisplayString(index + 1), 1),
                                _createElementVNode("i", {
                                  class: "delete-btn",
                                  onClick: ($event: any) => (removeMedia(element.id, 'image'))
                                }, "×", 8, _hoisted_16)
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageUploadProgress.value, (progress, key) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'progress-' + key,
                          class: "upload-progress-container"
                        }, [
                          _createElementVNode("div", _hoisted_17, [
                            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "progress-label" }, "图片上传中...", -1)),
                            _createVNode(_component_el_progress, {
                              percentage: progress,
                              "show-text": false
                            }, null, 8, ["percentage"])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _cache[13] || (_cache[13] = _createElementVNode("p", { class: "image-tip" }, "可上传图片，最多9张，拖拽调整顺序", -1))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "内容视频" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", {
                  class: "media-upload-area",
                  onClick: triggerVideoUpload
                }, [
                  _createElementVNode("input", {
                    ref_key: "videoInputRef",
                    ref: videoInputRef,
                    type: "file",
                    accept: "video/*",
                    onChange: handleVideoFileChange,
                    style: {"display":"none"}
                  }, null, 544),
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Plus))
                    ]),
                    _: 1
                  }),
                  _cache[14] || (_cache[14] = _createElementVNode("span", null, "添加视频", -1))
                ]),
                (videoList.value.length > 0 || videoUploadProgress.value > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      (videoUploadProgress.value > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "progress-label" }, "视频上传中...", -1)),
                              _createVNode(_component_el_progress, {
                                percentage: videoUploadProgress.value,
                                "show-text": false
                              }, null, 8, ["percentage"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoList.value, (video) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: video.id,
                          class: "video-full-container"
                        }, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("video", {
                              src: processMediaUrl(video.mediaUrl),
                              class: "video-full-preview",
                              controls: ""
                            }, null, 8, _hoisted_23),
                            _createElementVNode("div", _hoisted_24, [
                              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "media-type" }, "视频", -1)),
                              _createElementVNode("i", {
                                class: "delete-btn",
                                onClick: _withModifiers(($event: any) => (removeMedia(video.id, 'video')), ["stop"])
                              }, "×", 8, _hoisted_25)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _cache[17] || (_cache[17] = _createElementVNode("p", { class: "image-tip" }, "可上传视频，仅支持一个视频,推荐格式:.mp4", -1))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { class: "form-footer" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: submitForm,
                loading: submitting.value,
                disabled: !form.title || !form.content || uploadingMedia.value,
                class: "submit-btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(uploadingMedia.value ? '正在上传媒体...' : '发布帖子'), 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled"]),
              _createVNode(_component_el_button, {
                onClick: resetForm,
                class: "reset-btn"
              }, {
                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                  _createTextVNode("重置", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                onClick: cancel,
                class: "cancel-btn"
              }, {
                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                  _createTextVNode("取消", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: showPolishInstructionDialog.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showPolishInstructionDialog).value = $event)),
      title: "AI润色指令",
      width: "400px",
      center: "",
      class: "ai-polish-instruction-dialog"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_26, [
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (showPolishInstructionDialog.value = false)),
            class: "cancel-btn"
          }, {
            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: startPolishContent,
            loading: isPolishing.value,
            class: "confirm-btn"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(isPolishing.value ? '润色中...' : '开始润色'), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: polishInstruction.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((polishInstruction).value = $event)),
          type: "textarea",
          rows: 4,
          placeholder: "请输入润色指令，例如：让语言更生动有趣、调整为教程风格等",
          maxlength: "200",
          "show-word-limit": "",
          class: "custom-textarea"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: showPolishResultDialog.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showPolishResultDialog).value = $event)),
      title: "AI润色结果对比",
      width: "80%",
      top: "5vh",
      class: "polish-result-dialog"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_el_button, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (showPolishResultDialog.value = false)),
            class: "cancel-btn"
          }, {
            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
              _createTextVNode("不接受", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: acceptPolishedContent,
            disabled: isPolishing.value || !polishedContent.value,
            class: "confirm-btn"
          }, {
            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
              _createTextVNode(" 接受润色结果 ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _cache[22] || (_cache[22] = _createElementVNode("h3", null, "原始内容", -1)),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("pre", null, _toDisplayString(form.content), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _cache[24] || (_cache[24] = _createElementVNode("h3", null, "AI润色内容", -1)),
            _createElementVNode("div", _hoisted_31, [
              (isPolishing.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createVNode(_component_el_icon, {
                      class: _normalizeClass(['is-loading'])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Loading))
                      ]),
                      _: 1
                    }),
                    _cache[23] || (_cache[23] = _createElementVNode("span", null, "AI正在润色中...", -1))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "markdown-content",
                innerHTML: renderedPolishedContent.value
              }, null, 8, _hoisted_33)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})